import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * PD-1523 — the provider a patient actually saw, for the printable demographics
 * sheet. Alina asked for the scheduling provider rather than the PCP: "the
 * provider that they saw".
 *
 * Returns a flat provider block, never a FHIR resource. `phone` and `fax` are the
 * CLINIC's, not the practitioner's: providers asked that their personal contact
 * details stay off documents that leave the clinic. Only the name and the (public,
 * professional) NPI come from the Practitioner.
 */
export const getLastSeenProvider = oc
  .route({ method: 'GET', path: '/v2/appointments/last-seen-provider' })
  .input(z.object({ patientId: z.string() }))
  .output(
    z.object({
      provider: z
        .object({
          name: z.string(),
          npi: z.string(),
          phone: z.string(),
          fax: z.string(),
          /** Start of the visit this provider was seen at, ISO-8601. */
          seenOn: z.string().nullable(),
        })
        .nullable(),
    }),
  )
